import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Checkbox } from 'ui-components/components/checkbox';
import { Button } from 'ui-components/components/button';

import style from './edit-columns-modal.module.less';

const getPinButtonText = (isPinned, columnNameThatWillUnpin) => {
  if (isPinned) {
    return <FormattedMessage defaultMessage='Unpin' description='editColumnsModal.unpinColumn' id='TNU72y' />;
  }
  if (!columnNameThatWillUnpin) {
    return <FormattedMessage defaultMessage='Pin Column' description='editColumnsModal.pinColumn' id='5SaaOO' />;
  }
  return (
    <FormattedMessage
      defaultMessage='Pin (will unpin {columnNameThatWillUnpin})'
      description='editColumnsModal.pinColumnAndUnpinAnother'
      id='bhImyP'
      values={{ columnNameThatWillUnpin }}
    />
  );
};

export const ColumnRow = React.memo(
  ({
    columnId = '',
    columnName = '',
    isChecked = false,
    isPinned = false,
    onColumnChecked,
    onColumnPinToggle,
    columnNameThatWillUnpin,
  }) => {
    return (
      <div key={columnId} className={style['column-option']}>
        <div>
          <Checkbox checked={isChecked} label={columnName} onChange={() => onColumnChecked(columnId)} />
        </div>
        {isPinned && (
          <div className={style['pinned-text']}>
            <FormattedMessage defaultMessage='Pinned' description='editColumnsModal.pinned' id='K0ySbo' />
          </div>
        )}
        {isChecked && (
          <Button
            className={style['pin-unpin-button']}
            onClick={() => onColumnPinToggle(columnId)}
            testId={`pin-unpin-button-${columnId}`}
            theme='link'
          >
            {getPinButtonText(isPinned, columnNameThatWillUnpin)}
          </Button>
        )}
      </div>
    );
  },
);

ColumnRow.propTypes = {
  columnId: PropTypes.string,
  columnName: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  isChecked: PropTypes.bool,
  isPinned: PropTypes.bool,
  onColumnChecked: PropTypes.func.isRequired,
  onColumnPinToggle: PropTypes.func.isRequired,
  columnNameThatWillUnpin: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};
